import Loadable from '@loadable/component';

const LoadableSearch = Loadable(() => import('./index'));
export default LoadableSearch;
